import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW4002Model } from '../kymw4002.model';
import { KYMW4002PromotionModel } from '../vo/kymw4002-promotion.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * プロモーションマスタメンテナンス画面　プロモーションマスタ情報を削除するサービス
 *
 * @export DeletePromotionListService
 * @class DeletePromotionListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class DeletePromotionListService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW4002Model}
   * @memberof DeletePromotionListService
   */
  private model: KYMW4002Model;

  /**
   * 処理に使用するVO
   *
   * @private
   * @type {KYMW4002PromotionModel}
   * @memberof DeletePromotionListService
   */
  private vo: KYMW4002PromotionModel;

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof DeletePromotionListService
   */
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof DeletePromotionListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter:{
        PromotionNo: this.vo.promotionNo
      }
    })
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof DeletePromotionListService
   */
  execute(model: any, vo: any, successFunc: Function): void {
    this.model = <KYMW4002Model>model;
    this.vo = <KYMW4002PromotionModel>vo;
    this.successFunc = successFunc;
    this.send('KYMW40deletePromotionList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof DeletePromotionListService
   */
  success(data: any): void {
    this.successFunc(data);
  }

}
